<template>
  <div class="scroll-wrap" ref="wrapper" :class="{'is-auto-fold': autoFlod, 'is-show-selected': showSelectedInfo}">
    <div class="base-items" v-for="me in menue" :key="me.type" v-if="me.list">
      <h3 v-if="group">{{ me.name }}</h3>
      <evaluate-item
        v-for="(pitem, pindex) in me.list"
        :key="pindex"
        :show-selected-info="showSelectedInfo"
        :prev-img="prevImg"
        :auto-flod="autoFlod"
        :item="pitem"
        v-model="baseSelects[me.index + pindex]"
        v-show="fadeIn && currentValue.length > (me.index + pindex) - 1 || !fadeIn"
        :opening="computeOpen(me.index + pindex)"
        @select="select"
        @actionClick="actionClick"
        :multi="me.type === 2"
        :ref="`item${me.index + pindex}`"
        >
          <template slot="edit" slot-scope="{ opening }" v-if="$scopedSlots.edit">
            <slot name="edit" :opening="opening"></slot>
          </template>
          <template slot="name" v-if="$scopedSlots.name">
            <slot name="name" :item="pitem" :index="pitem.gIndex"></slot>
          </template>
          <template slot="answer" slot-scope="{ selected, item }" v-if="$scopedSlots.answer">
            <slot name="answer" :selected="selected" :item="item"></slot>
          </template>
        </evaluate-item>
    </div>
  </div>
</template>

<script type="text/javascript">
import EvaluateItem from './item';

const MUTIL_TYPE = '3';

export default {
  data () {
    return {
      current: 0,
      isMulti: MUTIL_TYPE,
      baseSelects: [],
      funcSelects: [],
      menue: [
        {
          type: 0,
          index: 0,
          name: '基本选项',
          list: []
        }, {
          type: 1,
          index: 0,
          name: '外观选项',
          list: []
        }, {
          type: 2,
          index: 0,
          name: '功能性问题',
          list: []
        }
      ]
    };
  },
  components: {
    EvaluateItem
  },
  props: {
    fadeIn: Boolean,
    showSelectedInfo: Boolean,
    autoFlod: Boolean,
    autoScroll: {
      type: Boolean,
      default: true
    },
    prevImg: Boolean,
    value: Array,
    group: Boolean
  },
  computed: {
    params () {
      const list = this.$store.state.productParam.params.itemList || [];
      list.sort((a, b) => {
        return +a.conftype - +b.conftype;
      });
      return list;
    },
    currentValue: {
      get () {
        return this.value || [];
      },
      set (value) {
        this.$emit('input', value);
      }
    },
    requiredLen () {
      return this.params.filter(item => item.conftype !== MUTIL_TYPE).length;
    },
    isCompleted () {
      return this.currentValue.length >= this.requiredLen;
    },
    outlookList () {
      return this.params.filter(item => item.conftype === '2');
    },
    baseList () {
      return this.params.filter(item => item.conftype === '1');
    },
    baseListLen () {
      return this.baseList.length;
    },
    funcList () {
      return this.params.filter(item => item.conftype === '3');
    }
  },
  methods: {
    culCurrentValue () {
      this.currentValue = this.baseSelects.concat(this.funcSelects).map(item => item.id).filter(item => item);
    },
    select (p, a, ev) {
      this.culCurrentValue();
      if (this.autoScroll) {
        this.$nextTick(() => {
          this.scroll(ev);
        });
      }
    },

    scroll (ev) {
      const st = document.body.scrollTop || document.documentElement.scrollTop;
      const nextCp = this.computeNext();
      if (!nextCp || this.isCompleted) {
        return;
      }
      this.$nextTick(() => {
        if (this.fadeIn) {
          window.scrollTo(0, nextCp.$el.offsetTop);
          return;
        }
        const nextEl = nextCp.$el.querySelector('.answer-item');
        const top = nextEl.getBoundingClientRect().top;
        const clientY = ev.clientY;
        const distance = (top + 10) - clientY;
        window.scrollTo(0, st + distance);
      });
    },
    setRef (type, index) {
      return `item${type + index}`;
    },

    computeOpen (index) {
      // if (!this.autoFlod) {
      //   return true;
      // }
      return this.current === index;
    },

    computeNext () {
      for (let i = 0; i <= this.requiredLen; i++) {
        const ref = this.$refs['item' + i] && this.$refs['item' + i][0];
        if (ref && (!ref.value || ref.value.length === 0)) {
          this.current = i;
          return ref;
        }
      }
    },

    actionClick (item) {
      this.current = this.params.findIndex(i => item.id === i.id);
    }
  },
  created () {
    this.menue[1].index = this.baseListLen;
    this.menue[2].index = this.requiredLen;
    this.menue[0].list = this.baseList;
    this.menue[1].list = this.outlookList;
    this.menue[2].list = this.funcList;

    if (this.currentValue.length) {
      const list = this.baseList.concat(this.outlookList);
      list.forEach(item => {
        this.baseSelects.push(item.questions.find(aitem => this.currentValue.find(id => aitem.id === id)));
      });
      this.funcList.forEach(item => {
        item.questions.forEach(aitem => {
          if (this.currentValue.find(id => aitem.id === id)) {
            this.funcSelects.push(aitem);
          }
        });
      });
      this.baseSelects.push(this.funcSelects);
    } else {
      const list = this.baseList.concat(this.outlookList).map(() => '');
      list.push(this.funcSelects);
      this.baseSelects = list;
    }

    let index = 0;
    this.menue.forEach(item => {
      item.list.forEach(i => {
        i.gIndex = index;
        index += 1;
      });
    });
  }
};
</script>

<style scoped>
.base-items /deep/ h3 {
  font-weight: 600;
  font-size: 20px;
  padding-bottom: 10px;
  margin-bottom: 20px;
  color: #333;
}

.is-auto-fold /deep/ .base-item-name {
  width: 6em;
}
</style>



// WEBPACK FOOTER //
// src/core/evaluate/evaluate.vue